var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.selectFacility,"label":_vm._f("translate")('Facility Name')},model:{value:(_vm.facility),callback:function ($$v) {_vm.facility=$$v},expression:"facility"}})}
var staticRenderFns = []

export { render, staticRenderFns }